import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ActivateViewFilterAction, DeactivateViewFilterAction } from "../../../../store/analytics/Analytics";
import { ApplicationState } from "../../../../store";
import { useState, useEffect } from "react";

export interface StringFilterProps {
    placeholder: string;
    viewId: string;
    filterId: string;
}

export function StringFilter(props: StringFilterProps) {
    const dispatch = useDispatch();

    const filterParams = useSelector((state: ApplicationState) => {
        const filter = state.analytics.views[props.viewId]?.filters[props.filterId];
        return filter?.params as string | undefined;
    });

    const isActive = useSelector((state: ApplicationState) => {
        const filter = state.analytics.views[props.viewId]?.filters[props.filterId];
        return filter?.isActive ?? false;
    });

    const [inputValue, setInputValue] = useState(filterParams ?? "");

    useEffect(() => {
        if (isActive && filterParams !== undefined) {
            setInputValue(filterParams);
        } else if (!isActive) {
            setInputValue("");
        }
    }, [filterParams, isActive]);

    function handleOnChange(e: React.ChangeEvent<HTMLInputElement>) {
        const value = e.target.value.toLowerCase();
        setInputValue(value);

        if (value === undefined || value === "") {
            dispatch({
                type: "analytics/deactivateViewFilter",
                payload: { viewId: props.viewId, filterId: props.filterId },
            } as DeactivateViewFilterAction);
        } else {
            dispatch({
                type: "analytics/activateViewFilter",
                payload: { viewId: props.viewId, filterId: props.filterId, parameter: value },
            } as ActivateViewFilterAction);
        }
    }

    return <Form.Control placeholder={props.placeholder} value={inputValue} onChange={handleOnChange} />;
}
